// removed by extract-text-webpack-plugin
module.exports = {"iconContainer":"FacebookConfirmationModal__iconContainer__95bc061d","icon":"FacebookConfirmationModal__icon__95bc061d","button":"FacebookConfirmationModal__button__95bc061d"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/Facebook/FacebookConfirmationModal.scss
// module id = 2630
// module chunks = 62